import React from "react";
import { useSelector } from "react-redux";
import { oneOf, string } from "prop-types";

import * as propTypes from "../../propTypes";
import hasUserAgentRole from "../../utilities/hasUserAgentRole";
import ProfileInfo from "../ProfileInfo";
import SearchModule from "../SearchModule";
import * as S from "./styled";

const HeroBlock = ({
  areaOptions,
  lastSearchType,
  priceWidgetTest,
  userProfile,
  userRole
}) => {
  const handleSignInModalOpen = event => {
    event.preventDefault();
    window.gon.state.triggerScenario("");
    window.gon.state.analyticsData = { source: "homepage_hero" };
  };
  const listingTypeSelector = state => state.listingType;
  const { listingType } = useSelector(listingTypeSelector);

  return (
    <S.HeroBlockWrapper listingType={listingType}>
      <S.HeroTitle>The easiest way to rent, buy & now sell in NYC</S.HeroTitle>
      <SearchModule
        areaOptions={areaOptions}
        lastSearchType={lastSearchType}
        priceWidgetTest={priceWidgetTest}
      />
      {userProfile ? (
        <>
          {!hasUserAgentRole(userRole) && (
            <ProfileInfo userProfile={userProfile} />
          )}
        </>
      ) : (
        <S.RegisterSignIn>
          Find the right home faster:{" "}
          <S.AuthLink href="#" onClick={handleSignInModalOpen}>
            register
          </S.AuthLink>{" "}
          or{" "}
          <S.AuthLink href="#" onClick={handleSignInModalOpen}>
            sign in
          </S.AuthLink>
        </S.RegisterSignIn>
      )}
    </S.HeroBlockWrapper>
  );
};

HeroBlock.defaultProps = {
  lastSearchType: "rentals",
  priceWidgetTest: "no_widget",
  userProfile: null,
  userRole: null
};

HeroBlock.propTypes = {
  areaOptions: propTypes.locations.isRequired,
  lastSearchType: string,
  priceWidgetTest: oneOf(["no_widget", "has_widget"]),
  userProfile: propTypes.profile,
  userRole: string
};

export default HeroBlock;
